import { FC, useMemo } from 'react'
import { Box, Image } from '../index'
import { loadingGifsMap } from '../../state/interfaces'

type loadingProps = {
  color: 'black' | 'dark-blue' | 'white'
}

export const Loading: FC<loadingProps> = ({ color }) => {
  const renderedGif = useMemo(() => loadingGifsMap[color], [color])

  return (
    <Box>
      <Image src={renderedGif} alt={`loading gif ${color}`} width={100} />
    </Box>
  )
}
